import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
    selector: '[tidyGoToNext]',
    standalone: false
})

export class GoToNextDirective  {
  private el: ElementRef;

  constructor(private _el: ElementRef) {
    this.el = this._el;
  }

  @HostListener('keydown', ['$event']) onKeyDown(e) {
    const hittenKey = e.keyCode || e.which;
    if (hittenKey === 13) {
      e.preventDefault();
      this.gotoNextElem();
    }
  }

  gotoNextElem() {
    const nodeList = document.querySelectorAll('input, textarea, ion-select');
    const currentIndex = this.findCurrentIndex(nodeList);

    const nextElemt = nodeList[currentIndex + 1] as HTMLElement;

    if (nextElemt) {
      setTimeout(() => {
        nextElemt.focus();
      }, 300);
    }
  }

  findCurrentIndex(nodeList) {
    const parent = this.el.nativeElement;
    const textarea = parent.querySelector('textarea');

    return Array.prototype.indexOf.call(nodeList, textarea);
  }
}
